import type { UnderlyingCodeType } from 'models/underlying/base';
import { connect } from 'react-redux';
import { getUserPreferencesUnderlyingCodeType } from 'state/selectors';
import type { AppState } from 'state/state.model';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

interface StateProps {
  defaultUnderlyingCodeType: UnderlyingCodeType;
}

export type UnderlyingsFieldProps = ProductNodeBuilderProps & StateProps;

const mapStateToProps = (state: AppState): StateProps => {
  const defaultUnderlyingCodeType = getUserPreferencesUnderlyingCodeType(state);
  return {
    defaultUnderlyingCodeType,
  };
};

export const connectUnderlyings = connect(mapStateToProps);
